import React from "react";
import { CircularProgress, Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import EmptyState from "./EmptyState";
import Icon from "./Icon";
import tokens from "../designTokens";

// Shared loading/error/not-found/empty branching so a 404 on a new endpoint
// never renders as if the data were simply empty.
export default function AsyncSection({ loading, notFound, error, empty, emptyTitle, emptyDescription, children }) {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={5}>
        <CircularProgress size={26} />
      </Box>
    );
  }
  if (notFound) {
    return (
      <Alert severity="warning" icon={<Icon name="info" size={18} />}>
        Not available yet — this is rolling out.
      </Alert>
    );
  }
  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }
  if (empty) {
    return (
      <EmptyState
        illustration={<Icon name="search-x" size={32} style={{ color: tokens.textHint }} />}
        title={emptyTitle || "Nothing here yet"}
        description={emptyDescription}
      />
    );
  }
  return children;
}
